<template>
    <b-row class="mt-5 pt-4 justify-content-center">
        <b-col cols="10">
            <h4 class="text-center mb-5">Status</h4>

            <b-row>
                <b-col :key="index" v-for="(item, index) in checkListFiltered">
                    <div class="d-flex flex-column justify-content-center align-items-center">
                        <b-spinner v-if="index == step"></b-spinner>
                        <b-icon-circle color="#0c3153" font-scale="2" v-if="!item.completed && step < index" />
                        <b-icon-circle-fill color="#0c3153" font-scale="2" v-if="item.completed" />
                        <p class="mb-0 text-center mt-3">{{ item.name }}</p>
                        <b-icon-arrow-right v-if="index < checkListFiltered.length - 1" font-scale="2"
                            class="icon-arrow" />
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-5 pt-4 justify-content-center">
                <b-col cols="12">
                    <p class="mb-0 text-center mt-3">Vent venligst. Du kan holde vinduet åbent imens skiltene printes. Hvis du har udfyldt email adresse vil du også få pdf'erne tilsendt.</p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>

</template>

<script>
import pdfService from '@/services/pdfService';

export default {
    name: "ProgressReport",
    props: ["URL", "intervalForStatus", "showEmailStep"],
    data() {
        return {
            interval: null,
            step: 0,
            backendStatus: 0,
            checkList: []
        }
    },
    computed: {
        checkListFiltered() {
            return this.$data.checkList.filter(f => !(f.key == "send-email" && !this.$props.showEmailStep))
        }
    },
    created() {
        this.rebuildCheckList();
    },
    watch: {
        showEmailStep() {
            this.rebuildCheckList();
        }
    },
    mounted() {
        this.interval = setInterval(async () => {
            let response = await pdfService.getProgress(this.$props.URL);
            if (response.data.runtimeStatus == "Failed") {
                this.$emit("generateFailed", response.data.output);
            }
            else if (response.customStatus.CustomStatus == 8) {
                this.$emit("generateCompleted", response.data);
            }
            else if (response.customStatus.CustomStatus == 99) {
                this.$emit("generateFailed", response.data.output.ErrorMessage);
            }
            else if (this.backendStatus < response.customStatus.CustomStatus) {
                this.applyBackendStatus(response.customStatus.CustomStatus);
            }
        }, this.$props.intervalForStatus);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        buildCheckList() {
            return [
                { key: "fetch-data", backendStatus: 0, name: "Henter data fra Commercetools", completed: false },
                { key: "build-signs", backendStatus: 2, name: "Bygger skilte", completed: false },
                { key: "build-codes", backendStatus: 3, name: "Bygger QR koder og stregkoder", completed: false },
                { key: "generate-html", backendStatus: 4, name: "Genererer pdf'er", completed: false },
                { key: "save-pdfs", backendStatus: 5, name: "Gemmer pdf'er", completed: false },
                { key: "merge-pdfs", backendStatus: 6, name: "Samler pdf'er", completed: false },
                { key: "send-email", backendStatus: 7, name: "Sender email", completed: false }
            ];
        },
        rebuildCheckList() {
            const currentStatus = this.backendStatus;
            this.checkList = this.buildCheckList();
            this.applyBackendStatus(currentStatus);
        },
        applyBackendStatus(status) {
            this.backendStatus = status;

            const visibleList = this.checkListFiltered;
            const newStepIndex = visibleList.findIndex(i => i.backendStatus === status);
            if (newStepIndex === -1) {
                return;
            }

            this.step = newStepIndex;

            for (let i = 0; i < visibleList.length; i++) {
                visibleList[i].completed = newStepIndex > i;
            }
        }
    }
}
</script>

<style scoped>
.icon-arrow {
    position: absolute;
    right: -15px;
    top: 20px;
}
</style>